import React from 'react';
import './Footer.css';

// ═══════════════════════════════════════════════════════════════
// FOOTER - Minimal, Low Cognitive Load
// ═══════════════════════════════════════════════════════════════

export const Footer = () => {
    return (
        <footer className="app-footer">
            <a
                href="https://youdontknowyou.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
            >
                youdontknowyou.com
            </a>
        </footer>
    );
};
